import { BorderColor, CheckCircle, KeyboardArrowRight } from '@mui/icons-material'
import { Button, capitalize, CircularProgress, Container, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik';
import TextInput from '../components/common/TextInput'
import PageContainer from '../components/PageContainer'
import $ from 'jquery'
import { useSnackbar } from 'notistack';
import { register, addQuestion } from '../redux/api/system';
import { useMediaQuery } from 'react-responsive';
import Countdown from "react-countdown";
import { dataCatalogue, partners } from '../util'
import Typewriter from 'typewriter-effect';
import OwlCarousel from 'react-owl-carousel';

const Home = () => {
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    const sm = useMediaQuery({ query: '(max-width: 490px)' })
    const history = useHistory()
    const params = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const [ success, setSuccess ] = useState(false);
    const [ open, setOpen ] = useState(false);
    const [ regEmail, setRegEmail ] = useState('');

    const strings =['Design & Implementation']

    return (
        <PageContainer pageTitle='Home'>
            <main>
                <div className="slider-area ">
                    <div className="slider-active">
                        <div className="single-slider slider-height d-flex align-items-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/img/bg/hand.jpg"})` }}>
                            <Container>
                                <div className="row">
                                    <div className="col-xl-9 col-lg-9 col-md-9" style={{ paddingRight: "50px" }}>
                                        <div className="hero__caption w-100">
                                            <p className="wow fadeInLeft mb-3" data-wow-delay=".4s" style={{}}>Statistical Resources: Connect, Share, Consume</p>
                                            <h1 className="wow fadeInLeft mt-2" data-wow-delay="0.9s">
                                                Making Data Available 
                                                <br />
                                                for Effective Policy
                                                <br />
                                                <Typewriter
                                                    options={{
                                                        strings,
                                                        autoStart: true,
                                                        loop: true,
                                                    }}
                                                />
                                            </h1>

                                            <div className="hero__btn" data-animation="fadeInLeft" data-delay=".8s">
                                                <Button endIcon={<KeyboardArrowRight />} href='#contact-us' variant="contained" color="secondary" style={{ minWidth: '200px' , minHeight: '50px'}}>Contact Us</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </div>
                </div>


                <div className="team-profile team-padding pt-6 pb-6">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="single-profile mb-30">

                                    <div className="single-profile-front">
                                        <div className="profile-img">
                                            <img src="assets/img/bg/lp.jpg" className='mb-2' alt="" style={{ height: '250px', objectFit: 'cover' }}/>
                                        </div>
                                        <div className="profile-caption">
                                            <h4 className='m-0 f-20'>Publish and Consume Data</h4>
                                            <p className='mt-05'>The portal facilitates the instantaneous and seamless sharing of macroeconomic data across Ministries, Departments and Agencies (MDAs) in a safe and confidential manner.
                                            <br />
                                            - Videos about the IDSP
                                            <br />
                                            - List of participating agencies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="single-profile mb-30">

                                    <div className="single-profile-front">
                                        <div className="profile-img">
                                            <img src="assets/img/bg/newpic.jpg" className='mb-2' style={{ height: '250px', objectFit: 'cover' }} alt="" />
                                        </div>
                                        <div className="profile-caption">
                                            <h4 className='m-0 f-20'>How to Join</h4>
                                            <p className='mt-05'>The IDSP has 18 MDAs onboarded and the list is growing. To be part of this initiative, please complete the <a href="/#contact-us" style={{ color: "#03a54f", fontWeight: "400", fontSize: "1em" }} >Contact Form</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="single-profile mb-30">

                                    <div className="single-profile-back-last">
                                        <h2>What the Portal Offers</h2>
                                        <p className='mt-05'>- Instant access to the most up-to-date data on different sectors of the Nigerian economy.
                                            <br />
                                            - Automated and safe platform for sharing data; thus improving the productivity of data officers in MDAs.
                                            {/* <br />
                                            - Eliminate bureaucratic bottlenecks associated with the manual processes for sharing macroeconomic data in Nigeria.
                                            <br />
                                            - Community of practice that facilitates exchange of ideas and knowledge among data officers in MDAs.</p> */}
                                            </p>
                                            <Link to="/login">Learn More »</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="we-trusted-area trusted-padding">
                    <div className="container">
                        <div className="row d-flex align-items-end">
                            <div className="col-xl-7 col-lg-7">
                                <div className="trusted-img">
                                    <img src="assets/img/bg/tab-2.jpg" alt="" />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-5">
                                <div className="trusted-caption">
                                    <h2>Over 5000 statistical data resources</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostru dolor sit amet, consectetur adipn.</p>
                                    <Button variant="contained">Learn More</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="services-area section-padding2">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-tittle text-center">
                                    <h2>Data Catalogue </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {
                                dataCatalogue.filter((d, index) => index < 3).map((cat, key) => (
                                    <div className="col-xl-4 col-lg-4 col-md-6" key={key}>
                                        <div className="single-services text-center mb-30">
                                            <div className="services-icon">
                                                {cat.icon}
                                            </div>
                                            <div className="services-caption">
                                                <h4>{capitalize(cat.title || '')}</h4>
                                                <p>
                                                    {cat.subCatalogues.filter((d, index) => index < 5).map(d => typeof(d) === 'string' ? d : d?.title).join(', ')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        <div className="row justify-content-center">
                            <div className="room-btn pt-50">
                                <Link to="/catalogues" className="border-btn">More Catalogues</Link>
                            </div>
                        </div>
                    </div>
                </div>


                <section id="sponsors" className="p-0 parallax-section" >
                    <section id="speakers" className=''>
                        <div className="container">
                            <div className="row">

                                <div className="col-md-12 col-sm-12 wow bounceIn">
                                    <div className="section-title">
                                        <h2>Partners</h2>
                                        {/* <p>Lorem ipsum dolor sit amet, maecenas eget vestibulum justo imperdiet.</p> */}
                                    </div>
                                </div>

                                {/* <!-- Testimonial Owl Carousel section
                                ================================================== --> */}
                                <OwlCarousel slideSpeed="5500" autoplayHoverPause autoplayTimeout="5000" className='owl-theme' loop margin={20} autoplay items={4} 
                                    responsive={{
                                        0: {
                                            items:1
                                        },
                                        600:{
                                            items:2
                                        },
                                        1000:{
                                            items:3
                                        },
                                        1200:{
                                            items:4
                                        }
                                    }}
                                >
                                    {
                                        partners.map((partner, key) => (
                                            <div key={key} className="item wow fadeInUp" data-wow-delay="0.9s" onClick={() => window.open(`${partner.link}`, "_blank")}>
                                                <div className="speakers-wrapper speakers pt-2 pb-2" title={partner.name}>
                                                    <img 
                                                        style={{ objectFit: 'contain', width: '200px', height: '200px', display:'block', margin: 'auto' }} 
                                                        src={process.env.PUBLIC_URL + "assets/images/" + partner.img} 
                                                        className="img-responsive" 
                                                        alt="partner" 
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </OwlCarousel>

                                <div className="col-12">
                                    <div className="section-title mt-4" id='contact-us'>
                                        <Link to="/partners">
                                            <Button style={{ fontSize: '14px' }} variant='outlined'>View All</Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>



                <div className="request-back-area section-padding">
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            {/* <div className="col-xl-4 col-lg-5 col-md-5">
                                <div className="request-content">
                                    <h3 className='mb-05'>Contact Form</h3>
                                    <p>Need more information? Send us a message</p>
                                </div>
                            </div> */}
                            <div className="contact">
                                <div className="request-content">
                                    <h3 className='mb-05'>Contact Form</h3>
                                    <p>Need more information? Send us a message</p>
                                </div>
                                <div className="form-wrapper label-white text-white mt-3">
                                    <Formik
                                        enableReinitialize initialValues={{ name: '', message: '', subject: '', email: '' }}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                        <TextInput id="name" label="Full name" />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextInput id="email" type="email" label="Email Address" style={{ BorderColor: "white" }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextInput id="subject" label="Subject" />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextInput id="message" multiline minRows={2} label="Message" />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>                                                
                                                        <Button type="submit" fullWidth color='secondary' variant='contained'>Send</Button>
                                                    </Grid>
                                                </Grid>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>

            </main>
        </PageContainer>
    )
}

export default Home